<template>
  <section>
    <!-- Main navbar -->
    <top-menu ref="topmenu" v-if="!refreshTopMenu" />

    <!-- Page content -->
    <div class="page-content">
      <!-- Main sidebar -->
      <LeftMenuAccountSetting v-show="leftMenuMyAccount" />
      <LeftMenu v-show="!leftMenuMyAccount" ref="lefMenu" />

      <ModalNearExpirePlan v-if="showNearExpire" />
      <ModalAppNearExpireAndExpire v-if="showAppNearExpire" />
      <div v-if="planTrial">
        <ModalExpiredPacketTrial />
      </div>
      <div v-else-if="showNewPlan">
        <ModalNewPlanSubscription />
      </div>
      <ModalDisableUpsell v-if="showDisableUpsell" />

      <div class="content-wrapper">
        <header-content />
        <alert-customer />
        <alert-order v-if="isShowAlertNewOldOrder && features.includes('feature-elasticsearch')"/>
        <!-- <alert-exceed-limit @showPageList="showPageModal" /> -->
        <alert-exceed-limit
           @showPageList="showPageModal"
           @showManageWarehouse="showManageWarehouse"
         />
        <ModalExceedLimitList v-if="isShowPagemodal" />
        <ModalManageWarehouse v-if="isShowPagemodalWarehouse" />
        <div class="content">
          <slot />
        </div>
        <footer-content ref="footerContent" />
      </div>
    </div>

    <modal-content ref="modalContent" />
    <!-- /page content -->
  </section>
</template>

<script>
import moment from "moment";
import TopMenu from "./admin/TopMenu";
import LeftMenu from "./admin/LeftMenu";
import LeftMenuAccountSetting from "./admin/LeftMenuAccountSetting";
import HeaderContent from "./admin/HeaderContent";
import FooterContent from "./admin/FooterContent";
import AlertCustomer from "./admin/AlertCustomer";
import AlertOrder from "./admin/AlertOrder";
import AlertExceedLimit from "./admin/AlertExceedLimit";
import ModalExceedLimitList from "./admin/ModalExceedLimitList";
import ModalManageWarehouse from "./admin/ManageWarehouse.vue";
import Cookies from "js-cookie";
import ModalNewPlanSubscription from "./admin/ModalNewPlanSubscription.vue";
import ModalNearExpirePlan from "./admin/ModalNearExpirePlan.vue";
import ModalExpiredPacketTrial from "./admin/ModalExpiredPacketTrial";
import ModalAppNearExpireAndExpire from "./admin/ModalAppNearExpireAndExpire";
import { convertTimezone } from "@/common/tenancy/convertTimezone";
import { humanDatetime } from "@/common/tenancy/datetime.js";
import ModalDisableUpsell from "./admin/ModalDisableUpsell.vue";
import Api from "@/services/endpoint/tenant.service.js";
import ModalContent from "./admin/ModalContent"

export default {
  name: "AdminLayout",
  components: {
    TopMenu,
    LeftMenu,
    LeftMenuAccountSetting,
    HeaderContent,
    FooterContent,
    AlertCustomer,
    AlertOrder,
    AlertExceedLimit,
    ModalExceedLimitList,
    ModalManageWarehouse,
    ModalNewPlanSubscription,
    ModalNearExpirePlan,
    ModalExpiredPacketTrial,
    ModalDisableUpsell,
    ModalAppNearExpireAndExpire,
    ModalContent,
  },
  data() {
    return {
      refreshTopMenu: false,
      showNewPlan: false,
      typeNewPlan: "",
      planTrial: false,
      tenantDomain: "",
      setting: {},
      planExpiredIn: "",
      showNearExpire: false,
      appExpiredIn: "",
      showAppNearExpire: false,
      showAppNearExpireType: "Near",
      showPlanNoti: false,
      showDisableUpsell: false,
      isShowPagemodal:false,
      isShowPagemodalWarehouse: false,
      isShowAlertNewOldOrder: false,
      tenant: JSON.parse(Cookies.get('tenant')),
      limitWarehouses: 1,
      planLists: {
        "free": 1,
        "basic": 1,
        "professional": 3,
        "advance": 5,
        "vip": 10
      },
      showPopUpModal: true,
      newVersionOrder: false,
      features: JSON.parse(Cookies.get('features')),

    };
  },
  computed: {
    leftMenuMyAccount() {
      if (this.$route.meta.switchLeftMenuMyAccount) {
        return this.$route.meta.switchLeftMenuMyAccount;
      } else {
        return false;
      }
    },
  },
  created() {
    try {
    this.$store.dispatch("user/getFeature", JSON.parse(Cookies.get('features')));
    this.$store.dispatch("user/getMenu", JSON.parse(Cookies.get('menus')));
    this.$store.dispatch("user/getPackage", Cookies.get("package"));
    this.$store.dispatch("user/getPlanSerie", JSON.parse(Cookies.get('plan')).series);
    this.$store.dispatch("user/getPlanGroup", JSON.parse(Cookies.get('plan')).group);
    this.limitWarehouses = this.planLists[JSON.parse(Cookies.get('plan')).series]
    this.$store.dispatch("user/getUser", JSON.parse(Cookies.get('user')));
    // this.$store.dispatch("user/getAnnouncements", JSON.parse(localStorage.getItem('announcements')));
    this.$store.dispatch(
      "user/getPlanTrialPeriod",
      Cookies.get("planTrialPeriod")
    );
    this.$store.dispatch(
      "user/getPlanTrialStartsAt",
      Cookies.get("planTrialStartsAt")
    );
    this.$store.dispatch(
      "user/getPlanTrialEndsAt",
      Cookies.get("planTrialEndsAt")
    );
    this.$store.dispatch(
      "user/getPlanLastPurchase",
      JSON.parse(Cookies.get("expiredPlans"))
    );

    if(!localStorage.getItem("provinces")){
      this.provinceData();
    }

    } catch(err) {
      console.log('AdminLayout', err)
    }
  },
  methods: {
    getExceedLimit: async function () {
      const exeedLimit = await Api.PlanSubscription.getExceedLimit();

      this.$store.dispatch(
        "user/showExceed",
        exeedLimit.data.data
      );

      // if(exeedLimit.data.data.length > 0){
        // $("#alert-exceedlimit").modal('show');
      // }
    },
    showPageModal(){
      this.isShowPagemodal = true;
      $("#alert-exceedlimit").modal('hide');
      setTimeout(() => {
        $("#modal_exceed_limit").modal('show');
      }, 1000);
    },
    isTimestampExpired(timestamp) {
      const currentTimestamp = new Date().getTime();
      const oneDayInMilliseconds = 24 * 60 * 60 * 1000; // 1 day in milliseconds

      return currentTimestamp - timestamp > oneDayInMilliseconds;
    },
    async showPopUp() {
      this.showPopUpModal = true;
      await this.popUpExpiredIntegration();
      await this.popUpNewPlanSubscription();
      if (!this.showPopUpModal) {
        return;
      }
      // this.getExceedLimit();
      // ------------------------Show expire trial plan ------------------------------------------
      let closePlanPacketTrial = Cookies.get(
        "closeTrialModal_" + this.tenant.id
      );

      let planActive = JSON.parse(Cookies.get('plan'));
      if (
        planActive && planActive.trial
      ) {
        let planTrialEndsAt = planActive.expire_date;
        let afterEnd3Day = new Date(planTrialEndsAt);
        afterEnd3Day.setDate(afterEnd3Day.getDate() + 3);
        let today = new Date();
        let currentTime = convertTimezone.utcToLocal(today);
        let planTrialEnds = convertTimezone.utcToLocal(planTrialEndsAt);
        let trialEndDate3Day = convertTimezone.utcToLocal(afterEnd3Day);
        if (
          currentTime > planTrialEnds &&
          currentTime <= trialEndDate3Day &&
          (!closePlanPacketTrial ||
            closePlanPacketTrial == "" ||
            closePlanPacketTrial == "undefined")
        ) {
          this.closePlanPacketTrial = closePlanPacketTrial;
          this.planTrial = true;
          this.showPlanNoti = true;
        }
      }

      // ------------------------Show near expire plan ---------------------------------------
      let clickOkNearExpireModal = Cookies.get(
        "okNearExpire_" + this.tenant.id
      );

      let today = new Date();
      let currentTime = moment(convertTimezone.utcToLocal(today));
      let planExpireTime = moment(
        convertTimezone.utcToLocal(planActive.expire_date)
      );

      this.planExpiredIn = moment
        .duration(currentTime.diff(planExpireTime))
        .asHours();
      if (
        this.planExpiredIn > 0 &&
        this.planExpiredIn <= 168 &&
        (!clickOkNearExpireModal ||
          clickOkNearExpireModal == "" ||
          clickOkNearExpireModal == undefined)
      ) {
        this.showNearExpire = true;
        this.showPlanNoti = true;
      }
      let closePopUpDisableUpsell = Cookies.get(
        "closeDisableUpsell_" + this.tenant.id
      );
      let clickAppOkNearExpireModal = Cookies.get(
        "okAppNearExpire_" +
          this.tenant.id +
          "_planUnmaskData"
      );
      let planExpire = JSON.parse(Cookies.get('expiredPlans'));
      let planActiveApps = planActive.apps;
      let planExpireApps = planExpire;
      // let planActiveUnmaskData = planActiveApps.find(app => app.slug.includes('app-marketing-unmasks'));
      const planActiveUnmaskDatas = planActiveApps.filter(app => app.slug.includes("app-marketing-unmasks"));
      const planActiveUnmaskData = planActiveUnmaskDatas.reduce((latest, app) => {
          return new Date(app.expire_date) > new Date(latest.expire_date) ? app : latest;
      }, planActiveUnmaskDatas[0]);

      let planExpireUnmaskData = planExpireApps.find(app => app.slug.includes('app-marketing-unmasks'));
      //case เปลี่ยน plan กระทันหัน และ เคสที่มีการกด modal trial ไปแล้วแต่ยังไม่ได้กดปิด upsell
      if (!this.showNewPlan && planActive.group != 'goship') {
        if (
          !["free", "basic"].includes(JSON.parse(Cookies.get('plan')).series) &&
          this.planExpiredIn > 0 &&
          this.planTrial == false &&
          this.showNewPlan == false &&
          (!closePopUpDisableUpsell ||
            closePopUpDisableUpsell == "" ||
            closePopUpDisableUpsell == undefined)
        ) {
          this.closePopUpDisableUpsell = closePopUpDisableUpsell;
          this.showDisableUpsell = true //ถ้า เป็น basic หรือ free ที่ถูกเปลี่ยนเป็น true เพราะไม่มีสิทธิใช้ Upsell แต่ถ้าเป็น profresh, advance, vip เป็น false
          this.showPlanNoti = true;
          this.$store.dispatch("user/showPlanNoti", this.showPlanNoti);
        }
        else if (
          this.planTrial == true || this.showNearExpire == true
        ) {
          this.showPlanNoti = true;
          this.$store.dispatch("user/showPlanNoti", this.showPlanNoti);
        }
        // --------------- -Show near expire app --------------- //
        else if (planActiveUnmaskData) {
          // Active
          let currentAppTime = moment(convertTimezone.utcToLocal(new Date()));
          let appExpireTime = moment(convertTimezone.utcToLocal(planActiveUnmaskData.expire_date));
          this.appExpiredIn = moment.duration(appExpireTime.diff(currentAppTime)).asHours();
          if (this.appExpiredIn > 0 && this.appExpiredIn <= 168 && (!clickAppOkNearExpireModal || clickAppOkNearExpireModal == "" || clickAppOkNearExpireModal == undefined)) {
            this.showAppNearExpireType = "Near";
            this.showAppNearExpire = true;
          }
        } else if (planExpireUnmaskData) {
          // DeActive
          let currentAppTime = moment(convertTimezone.utcToLocal(new Date()));
          let appExpireTime = moment(convertTimezone.utcToLocal(planExpireUnmaskData.expire_date));
          this.appExpiredIn = moment.duration(currentAppTime.diff(appExpireTime)).asHours();
          if (this.appExpiredIn > 0 && this.appExpiredIn <= 168) {
            if (!Cookies.get('okAppExpire_'+ this.tenant.id + '_planUnmaskData')) {
              this.showAppNearExpireType = "Expire";
              this.showAppNearExpire = true;
              Cookies.set('okAppExpire_'+ this.tenant.id + '_planUnmaskData', 'true', { domain: '.' + process.env.CENTRAL_API_ROOT, expires: 1 });
            } else {
              this.showPlanNoti = false;
              this.$store.dispatch("user/showPlanNoti", false);
            }
          } else {
            this.showPlanNoti = false;
            this.$store.dispatch("user/showPlanNoti", false);
          }
        } else {
          this.showPlanNoti = false;
          this.$store.dispatch("user/showPlanNoti", false);
        }
      }
    },
    async popUpExpiredIntegration() {
      if (!this.showPopUpModal) {
        return;
      }
      let countExpiredGochats = JSON.parse(Cookies.get('countExpiredGochats'));
      let countExpiredMarketplaces = JSON.parse(Cookies.get('countExpiredMarketplaces'));
      let numExpired = countExpiredGochats + countExpiredMarketplaces;
      let tenant = JSON.parse(Cookies.get('tenant'));
      const nearOrExpireIntegrations = Cookies.get('nearOrExpireIntegrations');
      if (numExpired > 0 && (!nearOrExpireIntegrations || this.isTimestampExpired(nearOrExpireIntegrations))) {
        this.$refs.lefMenu.marketPlaceExpire = tenant.need_upgrade_integration = true;
        Cookies.set('tenant', JSON.stringify(tenant), { domain: '.' + process.env.CENTRAL_API_ROOT });
        this.$store.dispatch("user/showPlanNoti", true);
        const currentTimestamp = new Date().getTime();
        Cookies.set('nearOrExpireIntegrations', currentTimestamp);

        let seft = this;
        let warnText = this.$t("Found X of your integrations have access token about to expire or has expired according to the partner's conditions.To continue using, please click to 'Manage Integration' and reauthorize. If an integration has been expired for more than 15 days, your integration will be automatically deleted.").replace("X", numExpired);
        this.$swal.fire({
          title: this.$t("Integration Expiration"),
          position: 'top',
          iconHtml:
            '<i class="fa-regular fa-exclamation-circle" style="font-weight:300; font-size:6rem;"></i>',
          iconColor: "#FF7043",
          html: `<div class="row mr-1 ml-1 pt-2">
                              <div class="col-3" style="background-color: #FC5F60 !important; border-radius: 3px 0px 0px 3px;">
                                  <i class="fa-regular fa-circle-info text-white" style="font-size: 2rem; margin: 0; position: absolute; top: 50%;  transform: translateY(-50%) translateX(-50%);"></i>
                              </div>
                              <div class="col-9 bbbb-soft-pink d-flex flex-column" style="background-color: #FFECEC !important; color:#FC5F60 !important; border-radius:0px 3px 3px 0px; padding: 7px 14px; text-align:left;">
                  <span>${warnText}</span>
              </div>
          </div>`,
          confirmButtonText: '<i class="fa-solid fa-circle-arrow-right mr-2"></i>' + this.$t('Manage Integration'),
          cancelButtonText: this.$t('Cancel'),
          showCancelButton: true,
          buttonsStyling: false,
          customClass: {
            confirmButton: "btn btn-primary",
            cancelButton: "btn btn-light",
          },
          preConfirm: async function () {
            seft.$router.push({ name: "t.a.integrations"});
          },
        });
        this.showPopUpModal = false;
        return true;
      }
      // this.$refs.lefMenu.marketPlaceExpire = tenant.need_upgrade_integration = false;
      Cookies.set('tenant', JSON.stringify(tenant), { domain: '.' + process.env.CENTRAL_API_ROOT });
      return false;
    },
    async popUpNewPlanSubscription() {
      if (!this.showPopUpModal) {
        return;
      }
      let user = JSON.parse(Cookies.get('user')),
          plan = JSON.parse(Cookies.get('plan')),
          planGroup = plan.group,
          planSeries = plan.series;
      let planName = (planGroup.charAt(0).toUpperCase() + planGroup.slice(1)) + ' ' + (planSeries.charAt(0).toUpperCase() + planSeries.slice(1));
      if (user && user.new_plan) {
        this.$store.dispatch("user/showPlanNoti", true);
        user.new_plan = false;

        delete user.login_date
        delete user.created_date
        delete user.updated_date

        Cookies.set('user', JSON.stringify(user), { domain: '.' + process.env.CENTRAL_API_ROOT });
        let seft = this;
        let warnText = this.$t("New plan {plan_name} start now, valid until {expired_date}. Some feature won't be support in this plan. Feel free to upgrade plan anytime.").replace("{plan_name}", planName).replace("{expired_date}", convertTimezone.utcToLocal(plan.expire_date));
        this.$swal.fire({
          title: this.$t("New Plan Found ") + ' !',
          position: 'top',
          iconHtml:
            '<i class="fa-regular fa-exclamation-circle" style="font-weight:300; font-size:6rem;"></i>',
          iconColor: "#FF7043",
          html: `<div class="row mr-1 ml-1 pt-2">
              <div class="col-1" style="background-color: #339EF4 !important; border-radius: 3px 0px 0px 3px;">
                  <i class="fa-solid fa-circle-info text-white" style="font-size: 1.5rem; margin: 0; position: absolute; top: 50%;  transform: translateY(-50%) translateX(-50%);"></i>
              </div>
              <div class="col-11 d-flex flex-column" style="background-color: #DBEEFD !important; color:#2196F3 !important; border-radius:0px 3px 3px 0px; padding: 7px 14px; text-align:left; border-style: solid; border-color: #339EF4 !important;">
                  <span>${warnText}</span>
              </div>
          </div>`,
          confirmButtonText: '<i class="fa-solid fa-envelope-open-dollar mr-2"></i>' + this.$t("Upgrade Now"),
          cancelButtonText: this.$t('Cancel'),
          showCancelButton: true,
          buttonsStyling: false,
          customClass: {
            confirmButton: "btn btn-primary",
            cancelButton: "btn btn-light",
          },
          preConfirm: async function () {
            location.href = window.location.origin + `/app/premium-subscriptions`;
          },
        });
        this.showPopUpModal = false;
      }
      return;
    },
    async provinceData(){
      let dataProvinces = [];
      await $.getJSON(Cookies.get("dbAddress"), function(data) {
        let lookup = [];
        let words = [];
        let expanded = [];
        let t;

        lookup = data.lookup.split('|');
        words = data.words.split('|');
        data = data.data;
        t = function (text) {
          function repl(m) {
            var ch = m.charCodeAt(0);
            return words[ch < 97 ? ch - 65 : 26 + ch - 97];
          }
          if (typeof text === 'number') {
            text = lookup[text];
          }
          return text.replace(/[A-Z]/ig, repl);
        };
        data.map(function (provinces) {
          var i = 1;
          if(provinces.length === 3){ // geographic database
            i = 2;
          }
          var entry = t(provinces[0]);
          if(i === 2){ // geographic database
            entry = provinces[1] || false;
          }
          expanded.push(entry);
        });
        dataProvinces = expanded
      });
      if(dataProvinces){
        localStorage.setItem("provinces", JSON.stringify(dataProvinces));
      }
    },
    showManageWarehouse(){
      let checkLimitwarehouse = JSON.parse(Cookies.get('WmsWarehouseLimit'))
      if (!checkLimitwarehouse) {
        this.$swal.fire({
        title: this.$t('Congratulations!'),
        text: this.$t('Your store has upgraded subscription.'),
        iconColor: "#FF7043",
        imageUrl: require('@/assets/global_assets/images/inventory/Congratulation.png'), // Replace with your image URL
        imageAlt: 'Custom Image',
        imageWidth: 170, // Adjust width as needed
        imageHeight: 120, // Maintain aspect ratio
        showCancelButton: false,
        confirmButtonText: '<i class="fa-solid fa-circle-check"></i> ' + this.$t("Got It!"),
        focusConfirm: false,
        customClass: {
          confirmButton: "btn btn-primary",
          loader: "custom-loader",
        },
        });
        setTimeout(() => {
          $("#alert-exceedlimit").modal('hide');
        }, 500);
      } else {
        this.isShowPagemodalWarehouse = true;
        $("#alert-exceedlimit").modal('hide');
        setTimeout(() => {
          $("#managewarehouse").modal('show');
        }, 1000);
      }
    },
  },
  watch: {
    $route(to, from){
      console.log('to',to)
      if(to.meta.title == 'Orders'){
        this.isShowAlertNewOldOrder = true;
      }else{
        this.isShowAlertNewOldOrder = false;
      }
    }
  },
  mounted() {
    this.showPopUp();

    if(!Cookies.get('new_version')){
      let myArray = [];
      Cookies.set('new_version',JSON.stringify(myArray))
    }else{
      this.newVersionOrder = JSON.parse(Cookies.get('new_version')).includes('order') ? true : false;
    }
  },

};
</script>



// WEBPACK FOOTER //
// src/layouts/tenancy/AdminLayout.vue